<template lang="html">
  <router-link
    v-if="to"
    :to="to"
    :class="theClass"
    @click="click"
    role="button"
  >
    <span class="button-inner">
      <slot></slot>
    </span>
  </router-link>
  <button
    :type="type ? type : 'button'"
    v-else
    :class="theClass"
    @click="click"
    role="button"
  >
    <span class="button-inner">
      <slot></slot>
    </span>
  </button>
</template>

<script>
export default {
  props: {
    to: {
      default: '',
    },
    size: {
      default: 3,
      type: Number,
    },
    type: '',
  },
  methods: {
    click() {
      this.$emit('click');
    },
  },
  computed: {
    theClass() {
      return 'button size-' + this.size;
    },
  },
};
</script>

<style lang="scss">
button.button,
a.button {
  position: relative;
  overflow: hidden;
  border: 0;
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  user-select: none;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  background-color: transparent;
  white-space: normal;

  &:disabled {
    opacity: 0.8;
  }

  &:after {
    content: '';
    transition: 0.3s;
    position: absolute;
    background-color: rgba(0, 0, 0, 0.2);
    // width: 100%;
    border: 0;
    // padding-top: 100%;
    z-index: 1;
    // border-radius: 50%;
    // left: 50%;
    // top: 50%;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    // transform: translate(-50%, -50%) scale(0,0);
    z-index: 1;
    margin: 0;
    opacity: 0;
    display: block;
    width: auto;
    height: auto;
    vertical-align: initial;
  }
  &:not(:disabled):not(.disabled) {
    cursor: pointer;
    &:hover {
      text-decoration: none;
      &:not(.disabled) {
        &:after {
          transition: 0.1s;
          // transform: translate(-50%, -50%) scale(1.05,1.05);
          opacity: 0.3;
        }
      }
    }
    &:active {
      &:after {
        transition: 0.1s;
        // transform: translate(-50%, -50%) scale(1.05,1.05);
        opacity: 0.4;
        border-radius: 0;
      }
    }
  }
  &:focus {
    box-shadow: none;
    outline: none;
  }
  & > .button-inner {
    position: relative;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    z-index: 2;
    text-decoration: none;
  }

  // BEHAVIOURS
  &.block {
    display: block;
    width: 100%;
  }

  // SIZES
  &.size-1 {
    padding: (size(3) / 2);
    font-size: (size(3) / 1.2);
  }
  &.size-2 {
    padding: (size(3) / 1.5);
    font-size: (size(3) / 1.1);
  }
  &.size-3 {
    padding: (size(3) / 1.3);
    font-size: (size(3));
  }
  &.size-4 {
    padding: (size(3) / 1.2);
    font-size: (size(3) * 1.2);
  }
  &.size-5 {
    padding: (size(3) / 1.1);
    font-size: (size(3) * 1.3);
  }

  // STYLES
  &.primary,
  &.primary.active,
  &.nav-link.active {
    background-color: color(primary);
    color: #fff !important;
  }
  &.linkedin {
    background-color: #0b6fa2;
    color: #fff !important;
  }
  &.danger {
    background-color: color(red);
    color: #fff !important;
  }
  &.green {
    background-color: color(green);
    color: #fff !important;
  }
  &.gray {
    background-color: gray(100);
    color: #333;
  }
  &.white {
    background-color: color(white);
    color: #333;
  }
  &.yellow {
    background-color: color(yellow);
    color: #856404;
    font-weight: bold;
  }
}

// // PROFILES
// .page-vibbrant {
//   .button.primary, .button.active {
//     background-color: color(vibbrant);
//   }
// }
// .page-client {
//   .button.primary, .button.active {
//     background-color: color(client);
//   }
// }
</style>



// WEBPACK FOOTER //
// src/parts/components/button.vue